import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import React from 'react';

interface Props {
  open: boolean;
  size?: number;
  color?: 'primary' | 'secondary' | 'inherit';
};

const Loading: React.FC<Props> = ({ open, size = 40, color = "primary" }) => {
  return (
    <Dialog open={open}>
      <DialogContent>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress size={size} color={color} />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default Loading;
